// KPI set erişimi — kullanıcı listesi yardımcıları (özet satırı, sıralama, kategori tavanı).
// Taslak modeli (v2: üç durumlu kategori, istisna, işletme) lib/client-access-draft-v2.ts'te;
// danışman › KPI erişimi kartı ve portal › Kullanıcılar çekmecesi onu ortak kullanır.
// Tavan: `consultantAccess === "closed"` kategoriler listede görünmez.

import type {
  ClientAdminSet,
  ClientAdminSetCategory,
  ClientUser,
  ClientUserSetAccess,
} from "@mahir/shared";

/** Müşteriye açılabilecek kategoriler (tavan: Set Yönetimi'nde kapalı olanlar dışarıda). */
export function visibleCategories(set: ClientAdminSet): ClientAdminSetCategory[] {
  return set.categories.filter((c) => c.consultantAccess !== "closed");
}

export function closedCategoryLabels(set: ClientAdminSet): string[] {
  return set.categories.filter((c) => c.consultantAccess === "closed").map((c) => c.label);
}

export interface AccessSummaryCopy {
  edits: string;
  views: string;
  allOpen: string;
  noneOpen: string;
  /** M17 — denetçi satır öneki ("denetçi"). */
  auditorTag: string;
}

/**
 * "düzenler: A, B · görüntüler: C" — portal `AccessSummary` ile aynı kural, tek satır.
 * Denetçi (M17): "denetçi · görüntüler: …" — sunucu denetçide `edits`'i boş döner.
 */
export function accessSummaryLine(a: ClientUserSetAccess, copy: AccessSummaryCopy): string {
  if (a.role === "auditor") {
    const scope =
      a.views.length === 0
        ? copy.noneOpen
        : `${copy.views} ${a.categoryAccess === null ? copy.allOpen : a.views.join(", ")}`;
    return `${copy.auditorTag} · ${scope}`;
  }
  if (a.categoryAccess === null && a.views.length === 0) {
    return `${copy.edits} ${a.edits.length > 0 ? copy.allOpen : copy.noneOpen}`;
  }
  const parts: string[] = [];
  if (a.edits.length > 0) parts.push(`${copy.edits} ${a.edits.join(", ")}`);
  if (a.views.length > 0) parts.push(`${copy.views} ${a.views.join(", ")}`);
  if (parts.length === 0) parts.push(copy.noneOpen);
  return parts.join(" · ");
}

/** Kapalı hesaba erişim yazılmaz (sunucu `user_closed` 409 ile aynı kural). */
export function canEditAccess(user: Pick<ClientUser, "status">): boolean {
  return user.status !== "closed";
}

/** Kart sırası: aktif/davetli önce, kapalı en sonda; eşitlikte ad. */
export function sortKpiUsers<T extends Pick<ClientUser, "status" | "fullName">>(users: T[]): T[] {
  const rank = (s: ClientUser["status"]): number => (s === "closed" ? 1 : 0);
  return [...users].sort(
    (a, b) => rank(a.status) - rank(b.status) || a.fullName.localeCompare(b.fullName, "tr"),
  );
}
